"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientRenderer = clientRenderer;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Iterates over the sharify `renderQueue` and attaches a rehydrated and rendered
 * component at its mountId attach point.
 */
function clientRenderer(_ref) {
  var _ref$wrapper = _ref.wrapper,
      Wrapper = _ref$wrapper === void 0 ? function (_ref2) {
    var children = _ref2.children;
    return children;
  } : _ref$wrapper,
      modules = _ref.modules;
  var components = Object.entries(modules).reduce(function (moduleMap, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        moduleName = _ref4[0],
        Module = _ref4[1];

    var Component = function Component() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      setTimeout(function () {
        if (!props.mountId) {
          console.error("[@artsy/stitch] Error mounting clientside component: `mountId` is " + "undefined. Did you forget to pass in a `mountId` in as a prop?");
        }

        var mountPoint = document.getElementById(props.mountId);

        if (!mountPoint) {
          console.error("[@artsy/stitch] Error mounting client-side component: Element not " + "found for #id '".concat(props.mountId, "'. Did you forget to create a ") + "DOM node to mount react to?");
        }

        _reactDom.default.hydrate(_react.default.createElement(Wrapper, null, _react.default.createElement(Module, props)), mountPoint);
      }, 0);
    };

    return _objectSpread({}, moduleMap, _defineProperty({}, moduleName, Component));
  }, {});
  return {
    components: components,

    /**
     * Executed when the client mounts
     */
    mount: function mount(_ref5) {
      var moduleName = _ref5.moduleName,
          component = _objectWithoutProperties(_ref5, ["moduleName"]);

      // Call the component with props, which triggers a render
      components[moduleName](_objectSpread({
        mountId: component.mountId
      }, component.props));
    }
  };
}
//# sourceMappingURL=clientRenderer.js.map